/*
 * Purpose : Admin Logs Landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, {useState, useEffect} from 'react'
import { Col, Row, Button, FormGroup, Label, Input } from 'reactstrap';
import moment from 'moment'

import ExportExcel from './../exportExcel/ExportExcel'
import LoadingModal from './../UI/modals/loadingModal';
//amplify
import { API, graphqlOperation } from 'aws-amplify';

const AppLogs = () => {
    const today = moment().format("YYYY-MM-DD")
    const lastSeventhDay = moment().subtract(7, 'days').format("YYYY-MM-DD")
    //console.log("today=>",today)
    //console.log("moment=>",moment().subtract(7, 'days').format("YYYY-MM-DD"));
   
    const [startDate, setStartDate] = useState(lastSeventhDay)
    const [endDate, setEndDate] = useState(today)
    const [logData, setLogData] = useState([])
    const [loading, setLoading] = useState(false)

    // to query the logs based on date range
    const getLogs = async (startDate, endDate) => {        
        const q = `query 
                    {
                        listExcesstransactionsloggers(limit:${process.env.REACT_APP_TRANSACTIONLOGS_TABLE_LIMIT}, filter: {loggeddate: {ge: "${startDate}" }, and: {loggeddate: {le: "${endDate}" }}, level: {eq: "error"} }) {
                            items {
                                level
                                loggeddate
                                message
                            }
                        }
                    }
                `;
                const apiData =await API.graphql(graphqlOperation(q))
                const results = apiData.data.listExcesstransactionsloggers.items;
                //console.log("results default=>",results)
                setLogData(results)
    }

    // call on click of Get logs button
    const getLogDetails = async () => {
            let startDate = new Date(document.getElementById("startDate").value)//.split('-');
            let endDate = new Date(document.getElementById("endDate").value)//.split('-');
            //console.log("startDate=>",startDate)
            //console.log("endDate=>",endDate)
            // To calculate the time difference of two dates 
            var Difference_In_Time = endDate - startDate;             
            //console.log("Difference_In_Time=>",Difference_In_Time)
            // To calculate the no. of days between two dates 
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
            //console.log("Difference_In_Days=>",Difference_In_Days)

            if(Difference_In_Days < 0){
                alert("End Date should not be less than Start Date");                
                return false;
            }else if(Difference_In_Days > 30){
                alert("Date range should not exceed 30 days");                
                return false;
            }
            else{
                let date1 = document.getElementById("startDate").value//.split('-');
                let date2 = document.getElementById("endDate").value//.split('-');
                //console.log(document.getElementById("startDate").value)   
                setLoading(true)             
                await getLogs(date1, date2);
                setLoading(false)             

            }
    }

    useEffect( () => {
        setLoading(true)
        const buildData = async () => {
            await getLogs(startDate, endDate)            
            //console.log("data=>",data)
            setLoading(false)
        }
        buildData()
    }, [] );
    //}, [startDate, endDate] );

    return (
        <div style={{margin:"0% 2%"}}>
            <LoadingModal open={loading} msg="Loading..." />
            <Row form>
                <Label for="startDate">Start Date</Label>
                <Col>
                    <FormGroup>
                        <Input
                            type="date"
                            name="date"
                            id="startDate"
                            //min ={today}
                            //defaultValue={today}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(event) => setStartDate(event.target.value)}
                            value={startDate}
                        />
                    </FormGroup>
                </Col>
                <Label for="endDate" >End Date</Label>
                <Col>
                    <FormGroup>
                        <Input
                            type="date"
                            name="date"
                            id="endDate"
                            //min ={today}
                            //defaultValue={today}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(event) => setEndDate(event.target.value)}
                            value={endDate}
                        />
                    </FormGroup>
                </Col>
                <Col >
                    <FormGroup >
                        <Button style={{backgroundColor:"#fb8734", width:"-webkit-fill-available", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0"}} 
                            onClick={()=>getLogDetails()}>Get Logs
                        </Button>
                    </FormGroup>
                </Col>
            </Row>
            <ExportExcel logData={logData} />
        </div>
    )
}
export default AppLogs